import { types } from 'mobx-state-tree';

export default types.model('StructuredDataOrg', {
    Context: types.string, // @context
    Type: types.string, // @type
    Name: types.string, // name
    Url: types.string, // url
    Logo: types.string, // logo
    SameAs: types.maybeNull(types.optional(types.array(types.string), []), []) // sameAs
}).views(self => ({

})).actions(self => ({
	
}));
